import React from "react";
import SaveIcon from '@material-ui/icons/Save';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    paper: {
      marginTop: theme.spacing(2),
      display: 'flex',
      flexGrow: 1,
      flexDirection: 'column',
      
    },
     textField: {
      
       marginTop:theme.spacing(2),
       marginBottom: theme.spacing(2),
       
       
     },
    }));


export const  Repetidata = (props) => {
    const classes = useStyles();

    const[datahorasaida, setadatahorasaida]=React.useState('');
    const[datahoraretorno, setadatahoraretorno]=React.useState('');
    const[desabilita, setadesabilita]=React.useState(false);
    const[desabilita2, setadesabilita2]=React.useState(true);
    var datas;
    function salvar(){
        var datas=[];
        if(((datahorasaida!='')&&(datahorasaida!=undefined)&&(datahorasaida!=null))&&
        ((datahoraretorno!='')&&(datahoraretorno!=undefined)&&(datahoraretorno!=null))){
            console.log("datas");
            setadesabilita(true);
            setadesabilita2(false);
            
            datas.push({datahorasaida:datahorasaida,datahoraretorno:datahoraretorno})
            console.log("datas" , datas);
            console.log("datas");
            props.setaparalistadatas(datas);

        }
    }

    function remover(){
        var datas=[];
        setadesabilita2(true);

        datas.push({datahorasaida:datahorasaida,datahoraretorno:datahoraretorno})
        props.removedata(datas)
        setadatahorasaida('');
        setadatahoraretorno('');
    }

    return (

<div>
        <TextField
      fullWidth
      disabled={desabilita}
      onChange={ e=>setadatahorasaida(e.target.value)}
      variant="outlined"
        id="datetimeini"
        label="Data e hora da Saída"
        type="datetime-local"
        value={datahorasaida}
        className={classes.textField}
        InputLabelProps={{
          shrink: true,
        }}
      />
      <TextField
      fullWidth
      disabled={desabilita}
      variant="outlined"
        id="datetimefim"
        label="Data e hora do Retorno (saída do local)"
        type="datetime-local"
        onChange={ e=>setadatahoraretorno(e.target.value)}
        value={datahoraretorno}
        className={classes.textField}
        InputLabelProps={{
          shrink: true,
        }}
      />
       <IconButton  id="btsalvar" aria-label="Remover"  disabled={desabilita2}
            onClick={remover}
            
           >
                    <DeleteIcon />
                  </IconButton>
                     
                  <IconButton  alignItems ="right" id="btsalvar" aria-label="Salvar" disabled={desabilita}
                        
                        onClick={salvar}
                          
                        >
                                <SaveIcon />
                              </IconButton> 

</div>
    )

}
export default {Repetidata}